import React, {useEffect} from 'react';
import {Auth} from 'aws-amplify';
import {observer} from 'mobx-react-lite';
import {Outlet, useLocation} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import HomePage from './app/layout/pages/Home';
import NavBar from './app/layout/components/authentication/NavBar';
import {useService} from './infrastructure/service/service';
import Box from '@mui/material/Box';
import {Container} from 'semantic-ui-react';

const App = () => {
  const location = useLocation();
  const { userService } = useService();

  useEffect(() => {
    const init = async (): Promise<void> => {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        if (cognitoUser)
          userService.setLoggedIn(true);
      } catch (ex) {
        userService.setLoggedIn(false);
      }

      if (userService.isLoggedIn())
        await userService.getCurrentUser();
    };

    init();
  }, []);

  return (
    <Box>
      <ToastContainer position="bottom-right" hideProgressBar />
      {
        location.pathname === '/' || location.pathname === '/login'
          ? <HomePage />
          : <Box>
              <NavBar />
              <Container>
                <Outlet />
              </Container>
            </Box>
      }
    </Box>
  );
}

export default observer(App);
